import { render, staticRenderFns } from "./SciTechContent.vue?vue&type=template&id=c2a2b230&scoped=true"
import script from "./SciTechContent.vue?vue&type=script&lang=js"
export * from "./SciTechContent.vue?vue&type=script&lang=js"
import style0 from "./SciTechContent.vue?vue&type=style&index=0&id=c2a2b230&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a2b230",
  null
  
)

export default component.exports